
    import '/opt/buildhome/repo/packages/x/docs/x-sdk/chat-provider.zh-CN.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-x-sdk-chat-provider-demo-basic","docs-x-sdk-chat-provider-demo-model"],
  getter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/x-sdk/chat-provider.zh-CN.md?type=demo')
};